import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import TeamMember, {
  TeamMemberProps
} from '@algbra/ui/components/TeamMember/TeamMember'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { graphql, StaticQuery } from 'gatsby'
import { mapIndexed } from 'rambdax'

const TEAMS_QUERY = graphql`
  query TeamQuery {
    strapiGQL {
      teams(sort: "Order", publicationState: LIVE) {
        ...StrapiGQL_TeamFragment
      }
    }
  }
`
export type ZoneTeamProps = {
  __typename: 'StrapiGQL_ComponentZonesTeam'
}
export default function ZoneTeam(props: ZoneTeamProps) {
  return (
    <StaticQuery
      query={TEAMS_QUERY}
      render={({ strapiGQL: { teams } }) => {
        return (
          <Whitespace type="md">
            <Container>
              <Row>
                {mapIndexed(
                  (node: TeamMemberProps, index) => (
                    <Column size={6} sm={4} lg={3} key={`team-column-${index}`}>
                      <TeamMember hasDialog={true} {...node} />
                    </Column>
                  ),
                  teams || []
                )}
              </Row>
            </Container>
          </Whitespace>
        )
      }}
    />
  )
}
